var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./data/keys'),
    ignore = _require.ignore;

var breathe = require('./utils/breathe'); //Groups DEVC entries by device


function groupDevices(_x) {
  return _groupDevices.apply(this, arguments);
}

function _groupDevices() {
  _groupDevices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(klv) {
    var result, _iterator, _step, _loop;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = {};
            _iterator = _createForOfIteratorHelper(klv.DEVC || []);
            _context2.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var d;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      d = _step.value;

                      if (!(d != null)) {
                        _context.next = 6;
                        break;
                      }

                      _context.next = 4;
                      return breathe();

                    case 4:
                      //Delete TICK and potentially other unused keys
                      ignore.forEach(function (i) {
                        if (d.hasOwnProperty(i)) delete d[i];
                      }); //Save to results inside device id key

                      if (result[d.DVID]) result[d.DVID].DEVC.push(d);else result[d.DVID] = {
                        DEVC: [d],
                        interpretSamples: 'DEVC'
                      };

                    case 6:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 5:
            if ((_step = _iterator.n()).done) {
              _context2.next = 9;
              break;
            }

            return _context2.delegateYield(_loop(), "t0", 7);

          case 7:
            _context2.next = 5;
            break;

          case 9:
            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t1 = _context2["catch"](2);

            _iterator.e(_context2.t1);

          case 14:
            _context2.prev = 14;

            _iterator.f();

            return _context2.finish(14);

          case 17:
            return _context2.abrupt("return", result);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[2, 11, 14, 17]]);
  }));
  return _groupDevices.apply(this, arguments);
}

module.exports = groupDevices;